import DeleteCampaignFieldMappingRequestModelBase from '../_generated/modelBases/delete-campaign-field-mapping-request-model-base';

export default class DeleteCampaignFieldMappingRequestModel extends DeleteCampaignFieldMappingRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/155/ViewModels-Models-DTOs
}
